import React from 'react';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';

import './Accordion.scss';

const Accordion = ({ items, className, ...restProps }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Collapse accordion={false} className={`accordion ${className}`} items={items} {...restProps} />
  );
};

Accordion.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      children: PropTypes.element
    })
  ).isRequired
};

Accordion.defaultProps = {
  className: ''
};

Accordion.Panel = Collapse.Panel;

export default Accordion;
